export default function IntroAppIcon({ width = 25, height = 25 }: { width?: number; height?: number }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M302.295 39.7007H104.428C46.7946 39.7007 0.12793 87.5219 0.12793 146.049V369.929C0.12793 428.457 47.0279 476.278 104.428 476.278H302.061C359.695 476.278 406.361 428.457 406.361 369.929V146.049C406.595 87.284 359.695 39.7007 302.295 39.7007Z"
        fill="url(#paint0_linear_527_23698)"
      />
      <path
        d="M258.194 0.491943H148.528C124.261 0.491943 104.428 20.4769 104.428 45.2203V67.5844C104.428 92.3278 124.028 112.313 148.294 112.313H258.194C282.461 112.313 302.061 92.3278 302.061 67.5844V45.2203C302.294 20.4769 282.461 0.491943 258.194 0.491943ZM175.594 356.177C171.161 356.177 166.728 354.512 163.228 350.943L128.228 315.256C124.973 311.898 123.148 307.367 123.148 302.646C123.148 297.925 124.973 293.394 128.228 290.037C134.994 283.137 146.194 283.137 152.961 290.037L175.594 313.114L256.561 230.557C263.328 223.658 274.528 223.658 281.294 230.557C288.061 237.457 288.061 248.877 281.294 255.777L187.961 350.943C184.694 354.512 180.028 356.177 175.594 356.177Z"
        fill="url(#paint1_linear_527_23698)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_527_23698"
          x1="203.245"
          y1="145.33"
          x2="201.336"
          y2="420.343"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EAF5FF" />
          <stop offset="1" stopColor="#CDDFF0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_527_23698"
          x1="203.245"
          y1="86.5498"
          x2="200.642"
          y2="310.587"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EAF5FF" />
          <stop offset="1" stopColor="#CDDFF0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
